module.exports = __webpack_public_path__ + "img/share-facebook.3546c812.svg";